import { store } from '../store/index';

export function authHeader() {
  const userToken = store.getters['account/getToken'];

  // return authorization header with jwt token
  if (userToken && userToken !== false) {
    return { 'Authorization': 'Bearer ' + userToken };
  }
  else {
    return {};
  }
}
